<template>
    <div style="max-width:480px;">
        <div class="wxOauth-bg">
            
        </div>
        <div class="wxOauth-loading">
            <div>
                <img src='../../../static/wxOauth/wxOauthLoading.gif' class="wxOauth-img"/>
            </div>
            <div class="wxOauth-span">登录中...</div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'
export default {
  computed: {
    ...mapGetters([
      'g_UserInfo'
    ]),
  },
  data(){
      return {
          isWXBrowser:typeof WeixinJSBridge == "undefined"?false:true,
          redirect:api.getDomainURL()
      }
  },
  activated() {
    //检查微信浏览器环境
    this.checkWXBrowser();
    //获取跳转链接
    this.redirect=this.$route.query.redirect;
    //   if(this.redirect==undefined||this.redirect.length==0||this.redirect.indexOf('https://i.998.com')<0){
    //       window.location.href='https://i.998.com';
    //alert("已经绑定过微信跳转链接:"+this.redirect);
    if(this.redirect==undefined||this.redirect.length==0||this.redirect.indexOf(api.getDomainURL())<0){
          window.location.href=api.getDomainURL();
      }else{
          this.checkLogin();
      }
      

  },
  methods:{
    //检查微信浏览器环境
    checkWXBrowser(){
        var ua = window.navigator.userAgent.toLowerCase(); 
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            this.isWXBrowser=true;
        }else{
            this.isWXBrowser=false;
        }
        //window.alert("是否为微信浏览器："+this.isWXBrowser);
        if(!this.isWXBrowser){
            window.location.href=this.redirect;
        }
    },
    checkLogin(){
        //如果已登录，直接跳转至对应页面
        var userInfo=this.g_UserInfo;
        if(this.g_UserInfo.Card_no == '' || this.g_UserInfo.Card_no == undefined){
            window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx384b5da598edc120&redirect_uri=http://h5.998.com/kosmos/apis/Account/WXAouthReturn&response_type=code&scope=snsapi_base&state="+this.redirect+"%23wechat_redirect";
            //window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+api.getWXCardAppId()+"&redirect_uri="+api.getDomainURL()+"/apis/Account/WXAouthReturn&response_type=code&scope=snsapi_base&state="+this.redirect+"%23wechat_redirect";
        }else{
            console.log("卡号"+this.g_UserInfo.Card_no+"wx330c5becf5a36a7f");
            var params = new this.URLSearchParam();
            params.append('cardNo', this.g_UserInfo.Card_no)
            this.$http.post(api.loginState(), params.toParam()).then((res) => {
                //window.alert("判断服务器登录状态："+res.Result);
                if (!res.Result) {
                    window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx384b5da598edc120&redirect_uri=http://h5.998.com/kosmos/apis/Account/WXAouthReturn&response_type=code&scope=snsapi_base&state="+this.redirect+"%23wechat_redirect";
                    //window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+api.getWXCardAppId()+"&redirect_uri="+api.getDomainURL()+"/apis/Account/WXAouthReturn&response_type=code&scope=snsapi_base&state="+this.redirect+"%23wechat_redirect";
                }
                else {
                    //window.alert("this.$route.query.redirect："+this.$route.query.redirect);
                    window.location.href=this.$route.query.redirect;
                }
            })
        }

        
    }
  }

}
</script>



<style lang="less" scope>
@import "../../assets/theme.less";
   .wxOauth-bg{
       background-color:#000000;
       opacity:0.6;
       position:absolute;top:0;bottom:0;left:0;right:0;
       max-width:480px;
   } 
   .wxOauth-loading{
       position:absolute;
       margin-top:3rem;
       width:70%;
       left:15%;
       background-color:#FFF;
       border-radius:4px;
       z-index:999;
       opacity:1;max-width:336px;
   }
   .wxOauth-img{
       padding-top:20px;
       padding-bottom:20px;
       width:70%;
       margin-left:15%;
   }
   .wxOauth-span{
       text-align:center;
       width:100%;
       padding-bottom:20px;
       color:#333333;
       font-size:0.33rem;
       display:none;
   }
</style>


// WEBPACK FOOTER //
// wxOauth.vue?2d2a6616